import {
  DsDialogService,
  DsDialogRef,
  DS_DIALOG_DATA,
  DsDialogConfig,
} from 'src/app/shared/components/ds-dialog/ds-dialog.component';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NamespacedIconName } from 'src/app/shared/constants/material-icon-name';

interface ShortcutEntry {
  keys: string[];
  description: string;
}

interface ShortcutGroup {
  category: string;
  icon: NamespacedIconName;
  shortcuts: ShortcutEntry[];
}

@Component({
  selector: 'app-keyboard-cheat-sheet',
  imports: [TranslateModule],
  templateUrl: './keyboard-cheat-sheet.component.html',
  styleUrls: ['./keyboard-cheat-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyboardCheatSheetComponent {
  constructor(public dialogRef: DsDialogRef<KeyboardCheatSheetComponent>) {}

  shortcutGroups: ShortcutGroup[] = [
    {
      category: 'Navigation',
      icon: 'explore',
      shortcuts: [
        { keys: ['Ctrl', 'K'], description: 'Open Command Palette' },
        { keys: ['Shift', '?'], description: 'Show This Help' },
        { keys: ['Alt', '1-9'], description: 'Switch Module' },
        { keys: ['Escape'], description: 'Close Dialog / Panel' },
        { keys: ['Ctrl', '\u2190'], description: 'Go Back' },
      ],
    },
    {
      category: 'Actions',
      icon: 'flash_on',
      shortcuts: [
        { keys: ['Ctrl', 'N'], description: 'New Record' },
        { keys: ['Ctrl', 'S'], description: 'Save' },
        { keys: ['Ctrl', 'E'], description: 'Export to CSV' },
        { keys: ['Ctrl', 'D'], description: 'Duplicate' },
        { keys: ['Delete'], description: 'Delete Selected' },
      ],
    },
    {
      category: 'Table',
      icon: 'table_chart',
      shortcuts: [
        { keys: ['Ctrl', 'A'], description: 'Select All Rows' },
        { keys: ['Space'], description: 'Toggle Row Selection' },
        { keys: ['\u2191', '\u2193'], description: 'Navigate Rows' },
        { keys: ['Enter'], description: 'Open Detail' },
      ],
    },
    {
      category: 'Search & Filter',
      icon: 'filter_list',
      shortcuts: [
        { keys: ['Ctrl', 'F'], description: 'Focus Search Field' },
        { keys: ['Ctrl', 'Shift', 'F'], description: 'Clear All Filters' },
      ],
    },
  ];
}
